import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { LandingPage } from './pages/LandingPage';
import { FAQPage } from './pages/FAQPage';
// Use window.location.pathname to determine if we're in a subdirectory
const getBasename = () => {
  // Extract the first path segment if it exists
  const pathSegments = window.location.pathname.split('/');
  return pathSegments.length > 1 ? `/${pathSegments[1]}` : '';
};
function PromptButton() {
  const handleClick = () => {
    const confirmed = window.confirm('This will throw an error for debugging purposes. Continue?');
    if (confirmed) {
      const text = window.prompt('Enter debug text to throw:');
      if (text !== null) {
        throw new Error(text);
      }
    }
  };
  // Only render in development
  if (window.location.hostname === 'localhost') {
    return <button onClick={handleClick} className="fixed right-0 top-0 z-50 w-4 h-4 opacity-0 cursor-default" aria-hidden="true" data-id="element-0">
        prompt
      </button>;
  }
  return null;
}
export function App() {
  // Set the document title when the component mounts
  useEffect(() => {
    document.title = 'Eedi Impact Evaluation';
  }, []);
  return <Router basename={getBasename()} data-id="element-1">
      <div className="flex flex-col min-h-screen bg-white" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<LandingPage data-id="element-7" />} data-id="element-6" />
            <Route path="/faq" element={<FAQPage data-id="element-9" />} data-id="element-8" />
            <Route path="/privacy" element={<div className="container mx-auto px-4 py-16" data-id="element-11">
                  <h1 className="text-3xl font-bold mb-4" data-id="element-12">Privacy Policy</h1>
                  <p data-id="element-13">This page is under construction.</p>
                </div>} data-id="element-10" />
            <Route path="/terms" element={<div className="container mx-auto px-4 py-16" data-id="element-15">
                  <h1 className="text-3xl font-bold mb-4" data-id="element-16">Terms of Service</h1>
                  <p data-id="element-17">This page is under construction.</p>
                </div>} data-id="element-14" />
            <Route path="/gdpr" element={<div className="container mx-auto px-4 py-16" data-id="element-19">
                  <h1 className="text-3xl font-bold mb-4" data-id="element-20">GDPR Compliance</h1>
                  <p data-id="element-21">This page is under construction.</p>
                </div>} data-id="element-18" />
          </Routes>
        </main>
        <Footer data-id="element-22" />
        <PromptButton data-id="element-23" />
      </div>
    </Router>;
}